import { BaseModel } from './BaseModel';

export interface Addon {
    name: string;
    display_name: string;
}

export class Addons extends BaseModel {
    [key: string]: any;

    get(name: string): Addon | undefined {
        if (this[name]) {
            return this[name];
        }
    }
}

export type AddonPlan = 'free' | 'community' | 'enterprise';

// Where an addon attaches. A panel addon is bought once; a license addon is
// bought per node, so its ownership is a count rather than a yes or no.
export type AddonScope = 'panel' | 'license';

// One entry of the admin addon showcase: the commercial metadata WISP holds
// for an addon, plus what it unlocks here and whether it is active.
export class AddonCatalogEntry extends BaseModel {
    public name = '';
    public displayName = '';
    public description: string | null = null;
    public price = 0;
    public trialable = false;
    public plan: AddonPlan | null = null;
    public scope: AddonScope = 'panel';
    public active = false;
    // Node-scoped addons only: how many of this panel's licensed nodes carry
    // this addon, out of how many could. Both are 0 at panel scope.
    public nodeCount = 0;
    public nodeTotal = 0;
    public requiresUpgrade = false;
    public billingUrl: string | null = null;
    public featureCount = 0;
    public tags: string[] = [];
    public included: string[] = [];
    public toggleable = false;

    getRouteID(): string {
        return this.name;
    }
}

// One addon attached to a single node's licence. Narrower than a catalogue
// entry on purpose: everything here is owned, so there is no active state,
// upgrade prompt or debug toggle to carry.
export class NodeAddon extends BaseModel {
    public name = '';
    public displayName = '';
    public description: string | null = null;
    public price = 0;
    public plan: AddonPlan | null = null;
    public scope: AddonScope = 'license';

    getRouteID(): string {
        return this.name;
    }
}
